export const DefaultLayoutConfig = {
    main: {
        type: 'default',
        primaryColor: '#04C8C8',
        darkSkinEnabled: true,
        pageBgWhite: false, // Set true if page background color is white
    },
    loader: {
        display: false,
        type: 'default', // Set default|spinner-message|spinner-logo to hide or show page loader
    },
    scrolltop: {
        display: true, // Enable scrolltop
    },
    header: {
        display: true,
        width: 'fixed',
        left: 'menu',
        fixed: {
            desktop: false,
            tabletAndMobile: false, // Set true|false to set fixed Header for tablet and mobile modes
        },
        menuIcon: 'svg',
    },
    aside: {
        display: true,
        theme: 'light',
        menu: 'main',
        fixed: true,
        minimized: false,
        minimize: false,
        hoverable: true,
        menuIcon: 'svg',
    },
    content: {
        width: 'fixed',
        layout: 'default',
    },
    toolbar: {
        display: true,
        width: 'fluid',
        fixed: {
            desktop: true,
            tabletAndMobileMode: true,
        },
        layout: 'toolbar1',
        layouts: {
            toolbar1: {
                height: '55px',
                heightAndTabletMobileMode: '55px',
            },
            toolbar2: {
                height: '75px',
                heightAndTabletMobileMode: '65px',
            },
            toolbar3: {
                height: '55px',
                heightAndTabletMobileMode: '55px',
            },
            toolbar4: {
                height: '65px',
                heightAndTabletMobileMode: '65px',
            },
            toolbar5: {
                height: '75px',
                heightAndTabletMobileMode: '65px',
            },
        },
    },
    footer: {
        width: 'fixed', // Set fixed|fluid to change width type
    },
    pageTitle: {
        display: true,
        breadCrumbs: true,
        description: false,
        responsive: true,
        responsiveBreakpoint: 'lg',
        responsiveTarget: '#kt_toolbar_container', // Responsive target selector
    },
    sidebar: {
        display: true, // only for dashboard
    },
};
